import {
    cilCloudUpload,
    cilDocument,
    cilEnvelopeOpen,
    cilHandshake,
    cilNote,
    cilPowerStandby,
    cilWidgets,
    cilEye,
    cilFilter,
    cilEyeSlash,
    cilCopy,
    cilExternalLink,
    cilWarning,
    cilXCircle,
    cilClock,
    cilLink,
    cilSend,
    cilSync,
} from '@coreui/icons-pro';

export const iconProSubset = {
    cilCloudUpload,
    cilDocument,
    cilEnvelopeOpen,
    cilHandshake,
    cilNote,
    cilPowerStandby,
    cilWidgets,
    cilEye,
    cilFilter,
    cilEyeSlash,
    cilCopy,
    cilExternalLink,
    cilWarning,
    cilXCircle,
    cilClock,
    cilLink,
    cilSend,
    cilSync
}

export enum IconProSubset {
    cilCloudUpload = 'cilCloudUpload',
    cilDocument = 'cilDocument',
    cilEnvelopeOpen = 'cilEnvelopeOpen',
    cilHandshake = 'cilHandshake',
    cilNote = 'cilNote',
    cilPowerStandby = 'cilPowerStandby',
    cilWidgets = 'cilWidgets',
    cilEye = 'cilEye',
    cilFilter = 'cilFilter',
    cilEyeSlash = 'cilEyeSlash',
    cilCopy = 'cilCopy',
    cilExternalLink = 'cilExternalLink',
    cilWarning = 'cilWarning',
    cilXCircle = 'cilXCircle',
    cilClock = 'cilClock',
    cilLink = 'cilLink',
    cilSend = 'cilSend',
    cilSync = 'cilSync'
}